// UI visibility flags — compile-time constants baked into the source/bundle.
//
// Use these to hide UI surfaces that may be re-enabled later. Unlike the runtime
// registry in src/config/featureFlags.js (which is overridable via localStorage),
// these are plain source constants, so a hidden surface cannot be re-exposed at
// runtime via devtools/localStorage.

// People (Contacts) tab in the left menu + the /contacts routes.
// Hidden for now; the underlying Contacts code is intentionally kept in place.
// Flip to `true` to fully restore the Contacts feature (menu button + routes).
export const SHOW_PEOPLE_TAB = false;
